import React, { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import moment from "moment";
import { useParams } from "react-router-dom";
import * as XLSX from "xlsx";
import { FiEye, FiEdit, FiTrash2 } from "react-icons/fi";


import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import CustomTable from "../../../components/table/table";
import Notification from "./notification/notification";
import { newCompanyStatus } from "./userStatus";
import {
  admin_applicationss_list,
  admin_messsage_view,
  superadmin_app_list,
  admin_msg_status_change,
  admin_domains_list,
  super_newcomp_delete,
} from "../admin.api";
import "./view.css";

const getStatusInfo = (status) => {
  const statusMap = {
    0: { label: "Pending", class: "pending", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg> },
    1: { label: "Submitted", class: "info", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></svg> },
    2: { label: "Accepted", class: "successs", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> },
    3: { label: "SA Reverted", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> },
    4: { label: "Rejected", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg> },
    5: { label: "Reverted", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M12 8v4m0 4h.01"></path></svg> },
    6: { label: "Agreement Execution", class: "info", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg> },
    7: { label: "Ongoing Project", class: "successs", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg> },
    8: { label: "Completed", class: "successs", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> },
    15: { label: "Suggestion", class: "info", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg> },
    16: { label: "Waiting", class: "pending", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg> },
  };
  const defaultIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="16" x2="12" y2="12"></line>
      <line x1="12" y1="8" x2="12.01" y2="8"></line>
    </svg>
  );
  return statusMap[status] || {
    label: "Unknown",
    class: "secondary",
    icon: defaultIcon
  };
};

export default function View(props) {
  const [data, setData] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  const [domains, setDomains] = useState([]);
  const [msgData, setmsgData] = useState([]);
  const premise = useParams().id;

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [showFilters, setShowFilters] = useState(true);
  const [isDownloading, setIsDownloading] = useState(false);
  const [filters, setFilters] = useState({
    status: "",
    domain: "",
    company_name: "",
  });

  const [openNotification, setOpenNotification] = useState(false);
  const [activeRow, setActiveRow] = useState({});

  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const getRequestList = () => {
    setIsActive(true);

    // Construct filters including the premise/area_type
    const activeFilters = {
      ...filters,
      area_type: premise === "own" ? "own_land" : "default"
    };

    const apiCall =
      adminType === 1 || adminType === 23
        ? admin_applicationss_list(page, perPage, activeFilters)
        : superadmin_app_list(page, perPage, activeFilters);

    apiCall.then((res) => {
      // Check if data exists in response, even if success flag is missing
      const responseData = res?.data || (Array.isArray(res) ? res : []);

      if (responseData) {
        const rawData = Array.isArray(responseData) ? responseData : [];

        rawData.forEach((item, index) => {
          item["slno"] = perPage === "all" ? index + 1 : (page - 1) * perPage + index + 1;
        });

        setData(rawData);
        // Look for last_page at the root level first, then inside pagination object
        const lastPage = res?.last_page || res?.pagination?.last_page || 1;
        setTotalPages(lastPage);
      }
      setIsActive(false);
    }).catch(() => {
      setIsActive(false);
    });
  };

  const getStatusList = () => {
    setStatuses(newCompanyStatus);
  };

  const getUserDomains = () => {
    admin_domains_list().then((res) => {
      setDomains(res.data || []);
    });
  };

  useEffect(() => {
    getRequestList();
  }, [page, perPage, filters]);

  useEffect(() => {
    getStatusList();
    getUserDomains();
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
    setPage(1);
  };

  const handlePerPageChange = (e) => {
    setPerPage(e.target.value);
    setPage(1);
  };

  const renderPagination = () => {
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);

    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }

    if (start > 1) {
      pages.push(
        <button key={1} className="btn btn-outline-primary" style={{ fontSize: "13px" }} onClick={() => setPage(1)}>1</button>
      );
      if (start > 2) pages.push(<span key="start-dots" className="px-1 text-primary">...</span>);
    }

    for (let i = start; i <= end; i++) {
      pages.push(
        <button
          key={i}
          className={`btn ${page === i ? "btn-primary text-white" : "btn-outline-primary"}`}
          style={{ fontSize: "13px" }}
          onClick={() => setPage(i)}
        >
          {i}
        </button>
      );
    }

    if (end < totalPages) {
      if (end < totalPages - 1) pages.push(<span key="end-dots" className="px-1 text-primary">...</span>);
      pages.push(
        <button key={totalPages} className="btn btn-outline-primary" style={{ fontSize: "13px" }} onClick={() => setPage(totalPages)}>{totalPages}</button>
      );
    }

    return pages;
  };

  const handleView = (item) => {
    const baseUrl = (adminType === 1 || adminType === 23) ? "/company-request-view" : "/superadmin-company-request-view";
    props.history.push(`${baseUrl}/${item.uuid}/${premise === "own" ? "own" : "kspace"}`);
  };

  const handleEdit = (data) => {
    props.history.push("/edit-application-premises/" + data.uuid);
  };

  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };

  const handleCancelDelete = () => {
    setOpenAction(false);
  };

  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    setIsActive(true);
    super_newcomp_delete(data.uuid)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
        getRequestList();
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  const notificationOpen = (data) => {
    admin_messsage_view(data.uuid).then((res) => {
      setmsgData(res.data);
    });
    setOpenNotification(true);
  };

  const notificationClose = () => {
    setOpenNotification(false);
    admin_msg_status_change(activeRow.uuid).then(() => {
      getRequestList();
    });
  };

  const handleNotification = (data) => {
    setActiveRow(data);
    notificationOpen(data);
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      getRequestList();
    }
  };

  const handleBulkEmail = () => {
    props.history.push(`/bulk-email/${premise === "own" ? "own" : "kspace"}`);
  };

  const downloadExcel = async () => {
    setIsDownloading(true);
    try {
      // Small delay to ensure loading state is visible
      await new Promise(resolve => setTimeout(resolve, 500));
      const exportData = await fetchExportData();
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Companies");
      const fileName = premise !== "own" ? "KSPACE_Premises_Companies.xlsx" : "Own_Premises_Companies.xlsx";
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      console.error("Error downloading Excel:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  async function fetchExportData() {
    const exportdata = [];
    data.forEach((item, index) => {
      const areaItems = Array.isArray(item.area_management) ? item.area_management.slice(0, 3) : [];
      const formatArea = (areaItem) => {
        if (!areaItem) return "";
        const areaType = areaItem.area_type;
        if (areaType === "built_up_space") {
          return [areaItem.location, areaItem.sub_location, areaItem.built_space_type, areaItem.area_in_sqft ? `${areaItem.area_in_sqft} sqft` : ""].filter(Boolean).join(" | ");
        }
        if (areaType === "land_on") {
          return [areaItem.location, areaItem.sub_location, areaItem.area_in_acres ? `${areaItem.area_in_acres} cents` : "", areaItem.lease_year ? `Lease: ${areaItem.lease_year} years` : ""].filter(Boolean).join(" | ");
        }
        return [areaItem.location, areaItem.area_in_sqft ? `${areaItem.area_in_sqft} sqft` : ""].filter(Boolean).join(" | ");
      };

      exportdata.push({
        ["Sl No"]: index + 1,
        ["Company Name"]: item.company_name,
        ["POC"]: item?.person_name,
        ["Email"]: item.email,
        ["Application Id"]: item.unique_application_ref_no,
        ["Date"]: item.created_at ? moment(item.created_at).format("DD-MMM-YYYY hh:mm A") : "--",
        ["Status"]: getStatusInfo(item.application_status).label,
        ["Requested Area 1"]: formatArea(areaItems[0]),
      });
    });
    return exportdata;
  }

  return (
    <>
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
      <div className="container-fluid mt-4">
        {openNotification && <Notification open={openNotification} close={notificationClose} msgData={msgData} />}
        <Snackbar message={snackMessage} error={isSnackError} open={snackOpen} close={snackbarClose} />
        <Loader open={isActive} />

        <div className="card shadow-sm">
          <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
            <h5 className="mb-0">
              <b>{premise !== "own" ? " Companies in KSPACE Premises" : "Companies in KSPACE - Own-Premises"}</b>
            </h5>
            <div className="d-flex gap-2">
              {adminType !== 2 && (
                <button className="btn btn-primary btn-sm" onClick={handleBulkEmail}>
                  Bulk Email
                </button>
              )}
              <button className="btn btn-primary btn-sm" onClick={downloadExcel} disabled={isDownloading}>
                {isDownloading ? (
                  <>
                    <svg className="me-2" style={{ width: "1.2rem", height: "1.2rem", animation: "spin 1s linear infinite" }} viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" strokeOpacity="0.25" />
                      <path d="M12 2C6.48 2 2 6.48 2 12" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
                    </svg>
                    Downloading...
                  </>
                ) : (
                  "Download Excel"
                )}
              </button>
              <button
                className={`filter-icon-btn ${showFilters ? "active" : ""}`}
                onClick={() => setShowFilters(!showFilters)}
                title="Toggle Filters"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
                </svg>
              </button>
            </div>
          </div>

          <div className="card-body pt-0">
            <div className={`filter-container ${showFilters ? "show" : ""}`}>
              <div className="row align-items-end">
                <div className="col-md-3">
                  <label className="form-label small">Company Name</label>
                  <input
                    type="text"
                    name="company_name"
                    className="form-control filter-select"
                    placeholder="Search company..."
                    value={filters.company_name}
                    onChange={handleFilterChange}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label small">Status</label>
                  <select name="status" className="form-control filter-select" value={filters.status} onChange={handleFilterChange}>
                    <option value="">All Statuses</option>
                    {statuses.map((item) => (
                      <option key={item.user_status_code} value={item.user_status_code}>
                        {item.user_status_title}
                      </option>
                    ))}
                    <option value={7}>Ongoing Projects</option>
                    <option value={6}>Agreement Execution</option>
                  </select>
                </div>
                <div className="col-md-3">
                  <label className="form-label small">Domain</label>
                  <select name="domain" className="form-control filter-select" value={filters.domain} onChange={handleFilterChange}>
                    <option value="">All Domains</option>
                    {domains.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.domain_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3 d-flex gap-2">
                  <button
                    className="filter-action-btn"
                    title="Reset Filters"
                    onClick={() => {
                      setFilters({ status: "", domain: "", company_name: "" });
                      setPage(1);
                    }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                      <path d="M3 3v5h5"></path>
                    </svg>
                  </button>
                  <button className="filter-action-btn close-btn" title="Close Filters" onClick={() => setShowFilters(false)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center mb-3 p-3 bg-light rounded border" style={{ fontSize: "14px" }}>
              <div className="d-flex align-items-center gap-3">
                <span className="text-muted fw-semibold">
                  Showing <span className="text-dark fw-bold">{data.length}</span> of <span className="text-dark fw-bold">{perPage === "all" ? data.length : totalPages * Number(perPage)}</span> records
                </span>
                <span className="badge bg-primary" style={{ fontSize: "13px", padding: "6px 12px" }}>
                  Page {page} of {totalPages}
                </span>
              </div>
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex align-items-center gap-2">
                  <label className="text-muted fw-semibold mb-0" style={{ fontSize: "13px" }}>Rows per page:</label>
                  <select className="form-select form-select-sm" value={perPage} onChange={handlePerPageChange} style={{ fontSize: "13px", height: "36px", width: "80px" }}>
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="all">All</option>
                  </select>
                </div>
                <div className="btn-group">
                  <button className="btn btn-outline-primary" disabled={page === 1} onClick={() => setPage((p) => p - 1)} style={{ fontSize: "13px" }}>Prev</button>
                  {renderPagination()}
                  <button className="btn btn-outline-primary" disabled={page === totalPages} onClick={() => setPage((p) => p + 1)} style={{ fontSize: "13px" }}>Next</button>
                </div>
              </div>
            </div>

            <CustomTable
              {...props}
              columns={[
                { title: "Sl No", field: "slno", style: { width: "70px", maxWidth: "70px" } },
                { title: "Company Name", field: "company_name" },
                { title: "Application ID", field: "unique_application_ref_no" },
                { title: "Email", field: "email" },
                {
                  title: "Created At",
                  field: "created_at",
                  render: (row) => (row.created_at ? moment(row.created_at).format("DD-MMM-YYYY") : "--"),
                },
                {
                  title: "Status",
                  field: "application_status",
                  render: (row) => {
                    const statusInfo = getStatusInfo(row.application_status);
                    return (
                      <span className={`status-badge ${statusInfo.class}`}>
                        <span className="status-icon">{statusInfo.icon}</span>
                        <span className="status-label">{statusInfo.label}</span>
                      </span>
                    );
                  },
                },
                {
                  title: "Action",
                  render: (row) => (
                    <div className="d-flex gap-1">
                      <button
                        className="btn btn-sm btn-outline-primary action-btn"
                        onClick={() => handleView(row)}
                        title="View"
                      >
                        <FiEye size={16} />
                      </button>
                      {(adminType === 1 || adminType === 2 || adminType === 23) && (
                        <button
                          className="btn btn-sm btn-outline-secondary action-btn"
                          onClick={() => handleEdit(row)}
                          title="Edit"
                        >
                          <FiEdit size={16} />
                        </button>
                      )}
                      {adminType === 2 && (
                        <button
                          className="btn btn-sm btn-outline-danger action-btn"
                          onClick={() => handleDelete(row)}
                          title="Delete"
                        >
                          <FiTrash2 size={16} />
                        </button>
                      )}
                    </div>
                  ),
                },
              ]}
              data={data}
              paging={false}
              options={{
                search: true,
                selection: false,
                exportButton: false,
              }}
              handleNotification={handleNotification}
            />
          </div>

          {openAction && (
            <ConfirmDialog
              open={openAction}
              title="Delete Company?"
              data={activeData}
              message="Are you sure you want to delete this company application?"
              secondary_action="Cancel"
              primary_action="Delete"
              handleClose={handleCancelDelete}
              handleConfirm={handleDeleteConfirm}
            />
          )}
        </div>
      </div>
    </>
  );
}
